import { useAppLead } from './useAppLead';
import { useAppRouter } from './useAppRouter';
import { useProducts } from './useProducts';

export const useCheckout = () => {
  const { locale } = useAppRouter();
  const { selectedPlan: plan } = useAppLead();
  const { findProductById, findTrialPrice, initialPlan } = useProducts();
  const selectedPlan = plan || findProductById(initialPlan['6']);

  const { finalPrice, price: initialPrice, currency } = useProducts(selectedPlan);
  const trialPrice = findTrialPrice(selectedPlan);
  const orderInitialPrice = trialPrice.price || initialPrice;
  const orderFinalPrice = trialPrice.finalPrice || finalPrice;

  const getServiceFee = () => {
    if (locale === 'en-US') {
      return 2.79;
    }

    return 0;
  };

  const getTax = (price: number) => {
    if (locale === 'en-GB') {
      return parseFloat((price * 0.2).toFixed(2));
    } else if (locale === 'en-AU') {
      return parseFloat((price * 0.1).toFixed(2));
    } else if (locale === 'en-CA') {
      return parseFloat((price * 0.0975).toFixed(2));
    }

    return 0;
  };

  const orderInitialAfterTax = orderInitialPrice - getTax(orderInitialPrice);
  const orderInitialAfterServiceFee = orderInitialAfterTax - getServiceFee();

  return {
    selectedPlan,
    currency,
    finalPrice: orderFinalPrice,
    finalBeforeServiceFeePrice: orderFinalPrice - getServiceFee(),
    initialPrice: orderInitialPrice,
    initialPriceAfterServiceFee: orderInitialAfterServiceFee,
    initialPriceAfterTax: orderInitialAfterTax,
    initialPriceForDiscount: orderInitialPrice + getTax(orderInitialPrice) + getServiceFee(),
    tax: getTax(orderInitialPrice),
    serviceFee: getServiceFee(),
    getProductInitialPrice: (productId: string) => {
      const product = findProductById(productId);
      const { finalPrice, price } = findTrialPrice(product);

      return finalPrice - getServiceFee() - getTax(price);
    },
    taxName: locale === 'en-GB' ? 'VAT' : locale === 'en-AU' ? 'GST' : locale === 'en-CA' ? 'Taxes' : null,
  };
};
